export default __webpack_public_path__ + "static/media/hhs-qld-mackay.a2fb7948.svg";